// import React, { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { setLoginData, setLoading, setError } from '../../Redux/user_information';
// import { login_data } from '../../Services/Operations/ProductAPI';
// import '../../Styles/AdminLaout.css';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';

// const Login = ({ onLogin, onForgotPassword }) => {
//     const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     email: '',
//     password: ''
//   });
//   const [showPassword, setShowPassword] = useState(false);
  
//   const dispatch = useDispatch();
//   const { isLoading, error } = useSelector((state) => state.user);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!formData.email || !formData.password) {
//       dispatch(setError('Please fill in all fields'));
//       return;
//     }

//     dispatch(setLoading(true));
//     dispatch(setError(null));

//     try {
//       const loginResponse = await login_data({
//         email: formData.email,
//         password: formData.password
//       });

//       if (loginResponse.success) {
//         dispatch(setLoginData(loginResponse));

//         if (onLogin) {
//           onLogin(loginResponse);
//         }
        
//         console.log('Login successful:', loginResponse);
//         navigate("/")
//       } else {
//         dispatch(setError(loginResponse.message || 'Login failed'));
//       }
//     } catch (error) {
//       console.error('Login error:', error);
//       dispatch(setError('Login failed. Please check your credentials.'));
//     } finally {
//       dispatch(setLoading(false));
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });

//     if (error) {
//       dispatch(setError(null));
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div className="login-page">
//       <div className="login-container">
//         <div className="login-header">
//           <h1>Admin Login</h1>
//           <p>Sign in to your account</p>
//         </div>
        
//         {error && (
//           <div className="error-message">
//             {error}
//           </div>
//         )}
        
//         <form className="login-form" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label htmlFor="email">Email Address</label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               placeholder="Enter your email"
//               required
//               disabled={isLoading}
//             />
//           </div>
          
//           <div className="form-group password-group">
//             <label htmlFor="password">Password</label>
//             <div className="password-input-wrapper">
//               <input
//                 type={showPassword ? 'text' : 'password'}
//                 id="password"
//                 name="password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 placeholder="Enter your password"
//                 required
//                 disabled={isLoading}
//               />
//               <button
//                 type="button"
//                 className="password-toggle-btn"
//                 onClick={togglePasswordVisibility}
//                 disabled={isLoading}
//                 aria-label={showPassword ? 'Hide password' : 'Show password'}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </button>
//             </div>
//           </div>
          
//           <button 
//             type="submit" 
//             className="login-btn"
//             disabled={isLoading}
//           >
//             {isLoading ? 'Signing In...' : 'Sign In'}
//           </button>
          
//           <div className="login-footer">
//             <button 
//               type="button" 
//               className="forgot-password-btn"
//               onClick={() => navigate('/forgot-password')}
//               disabled={isLoading}
//             >
//               Forgot Password?
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginData, setLoading, setError } from '../../Redux/user_information';
import { login_data } from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions
import '../../Styles/CustomerReport.css';       // customer-only additions
import '../../Styles/AdminLaout.css';           // legacy login styles (kept for compat)
import { useNavigate } from 'react-router-dom';
import { Icon, BusSvg } from './PrimaryUI';

const Login = ({ onLogin, onForgotPassword }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, error } = useSelector((state) => state.user);

  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      dispatch(setError('Please fill in all fields'));
      return;
    }

    dispatch(setLoading(true));
    dispatch(setError(null));

    try {
      const loginResponse = await login_data({
        email: formData.email,
        password: formData.password
      });

      if (loginResponse.success) {
        dispatch(setLoginData(loginResponse));
        if (onLogin) onLogin(loginResponse);
        console.log('Login successful:', loginResponse);
        navigate('/');
      } else {
        dispatch(setError(loginResponse.message || 'Login failed'));
      }
    } catch (error) {
      console.error('Login error:', error);
      dispatch(setError('Login failed. Please check your credentials.'));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (error) dispatch(setError(null));
  };

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  return (
    <div className="prm-login-page">
      {/* ===================== LEFT — BRAND PANEL ===================== */}
      <div className="prm-login-brand">
        <div className="prm-login-brand-inner">
          <div className="prm-login-logo">
            <div className="prm-sidebar-logo" style={{ transform: 'scale(1.15)' }}>
              <span className="prm-sidebar-logo-dot" />
              <span className="prm-sidebar-logo-dot" />
              <span className="prm-sidebar-logo-dot" />
            </div>
            <div>
              <h2>ROAM</h2>
              <span className="prm-sidebar-tagline">Admin Console</span>
            </div>
          </div>

          <h1 className="prm-login-headline">
            Manage your bus network,<br />
            <span>one dashboard at a time.</span>
          </h1>
          <p className="prm-login-subline">
            Routes, bookings, owners, drivers, conductors, commissions and analytics — all in one place.
          </p>

          <ul className="prm-login-features">
            <li><Icon name="check" size={16} /> Live booking & revenue analytics</li>
            <li><Icon name="check" size={16} /> Weekly & monthly recurring routes</li>
            <li><Icon name="check" size={16} /> Owner commissions & influencer payouts</li>
            <li><Icon name="check" size={16} /> Complete audit trails & activity logs</li>
          </ul>

          <div className="prm-login-road" aria-hidden="true">
            <div className="prm-login-road-dashes" />
            <span className="prm-login-road-bus">
              <BusSvg size={64} />
            </span>
          </div>
        </div>

        <div className="prm-login-foot">© {new Date().getFullYear()} ROAM · All rights reserved</div>
      </div>

      {/* ===================== RIGHT — FORM PANEL ===================== */}
      <div className="prm-login-form-wrap">
        <div className="prm-login-form-card">
          <div className="prm-login-form-head">
            <span className="prm-eyebrow"><Icon name="user" size={13} /> Sign In</span>
            <h2>Welcome back</h2>
            <p>Sign in to continue to the admin console.</p>
          </div>

          {error && (
            <div className="prm-login-error">
              <Icon name="info" size={16} />
              <span>{error}</span>
            </div>
          )}

          <form className="prm-login-form" onSubmit={handleSubmit} noValidate>
            <div className="prm-field">
              <label className="prm-label">Email Address<em>*</em></label>
              <div className="prm-login-input-wrap">
                <span className="prm-login-input-ico"><Icon name="mail" size={16} /></span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="you@roam.com"
                  disabled={isLoading}
                  autoComplete="username"
                  className="prm-input prm-login-input"
                  required
                />
              </div>
            </div>

            <div className="prm-field">
              <label className="prm-label">Password<em>*</em></label>
              <div className="prm-login-input-wrap">
                <span className="prm-login-input-ico"><Icon name="tag" size={16} /></span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  disabled={isLoading}
                  autoComplete="current-password"
                  className="prm-input prm-login-input"
                  required
                />
                <button
                  type="button"
                  className="prm-login-eye"
                  onClick={togglePasswordVisibility}
                  disabled={isLoading}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  title={showPassword ? 'Hide password' : 'Show password'}
                >
                  <Icon name={showPassword ? 'eye-off' : 'eye'} size={16} />
                </button>
              </div>
            </div>

            <div className="prm-login-meta">
              <label className="prm-check" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    // optional "remember me" – no-op, hook up if backend supports
                  }}
                />
                <span className="txt">Remember me</span>
              </label>

              <button
                type="button"
                className="prm-login-link"
                onClick={() => navigate('/forgot-password')}
                disabled={isLoading}
              >
                Forgot password?
              </button>
            </div>

            <button
              type="submit"
              className="prm-btn primary prm-login-submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="prm-login-spinner" /> Signing in…
                </>
              ) : (
                <>
                  <Icon name="check" size={16} /> Sign In
                </>
              )}
            </button>
          </form>

          <div className="prm-login-form-foot">
            <span>Need help? Contact your system administrator.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;